import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { isFamilySubsAvailable } from 'reactApp/appHelpers/featuresHelpers';
import { SPACE_LIST } from 'reactApp/constants/spaceList';
import { getBillingDataRequestIfNotLoaded } from 'reactApp/modules/billingData/billingData.module';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

export function useUserCanCreateFamilyByBilling() {
    const dispatch = useDispatch();
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const space = useSelector(UserSelectors.getCloudSpace);
    const isValidUser =
        !isCorpUser && !isBizUser && isPaidUser && space.total.original > SPACE_LIST.gb_9 && !IS_ONPREMISE && isFamilySubsAvailable;
    useEffect(() => {
        if (isValidUser) {
            dispatch(getBillingDataRequestIfNotLoaded());
        }
    }, [isValidUser]);

    const canCreateFamily = useSelector(BillingDataSelectors.isUserCanCreateFamilyByBilling);
    return isValidUser && canCreateFamily;
}
